export const commonStyles = {
  // 詳細ページの一覧
  showPageInnerList: {
    "& .MuiTableCell-sizeSmall": {
      padding: "6px 8px",
    },
    "& .MuiTableCell-root": {
      minWidth: "2em",
    },
  },
  showPageInnerDatagrid: {
    display: "inline-block",
  },
  mobileTabbedShowLayout: {
    "& .MuiTab-root": {
      flex: { xs: "1 1 0", sm: "0 0 auto" },
      minWidth: { xs: 0, sm: "90px" },
      px: { xs: 1, sm: 2 },
    },
  },
  showPageWordBreakTextField: {
    wordBreak: "break-all",
    whiteSpace: "pre-wrap",
  },
};
